import { useMemo } from "react";

import { OrderableList, PROP_PANEL_PADDING } from "@skilitics/designer-ui-components";
import type { UniqueIdentifier } from "@skilitics/drag-drop";

import { NodeDesigner } from "../../../NodeDesigner";
import type { DesignerNode } from "../../../types";
import { BackgroundPropertiesRow } from "./BackgroundPropertiesRow";

type Props = {
  images: DesignerNode[];
  onRemove: (id: number) => void;
  onOrderChange: (key: UniqueIdentifier, newIndex: number) => void;
};

export const BackgroundImages = ({ images, onRemove, onOrderChange }: Props) => {
  const sortableIds = useMemo(() => images.map((image) => image.id), [images]);

  return (
    !!sortableIds.length && (
      <OrderableList
        orderByKey={sortableIds}
        sortingStrategy="vertical"
        onOrderChange={onOrderChange}
        dragSize={12}
        handle
        style={{
          gap: "8px",
          marginBottom: "8px",
          marginLeft: `-${PROP_PANEL_PADDING - 5}px`,
        }}
      >
        {images.map((n) => (
          <BackgroundPropertiesRow key={n.id} onRemove={() => onRemove(n.id)}>
            <NodeDesigner node={n} view="properties" />
          </BackgroundPropertiesRow>
        ))}
      </OrderableList>
    )
  );
};
